import React, { useState } from "react";
import { TextField, Tooltip } from "@mui/material";
import { set } from "lodash";
import { errorJsonHasErrors } from "./Input_Fns";

export const InputYear = ({
  year,
  label,
  name = "Year",
  minAge = 18,
  maxAge = 100,
  required = true,
  birthYear = 0,
  onChange,
  disabled,
  tooltip = "",
  errors_ = null,
  onError = null,
  width = 85,
  ...others
}) => {
  const [errors, setErrors] = useState({})

  const onBlur = (e) => {
    let ne = structuredClone(errors)
    let err = ""



    if (e.target.name === name) {
      if ((required || (!required && year > 0)) && (birthYear !== 0 && (year < birthYear + minAge || year > birthYear + maxAge))) {
        let min = birthYear + minAge
        //err = "Please enter a year between " + min + " - " + (birthYear + maxAge)
        err = "" + min + " to " + (birthYear + maxAge)

      }
      if (errors_ !== null && err === "" && errors_[name] !== "") {
        err = errors_[name]
      }

    }
    //console.log(err)
    ne = set(ne, e.target.name, err)
    setErrors(ne)
    //console.log(ne)
    if (onError !== null) {
      onError(errorJsonHasErrors(ne) ? "Errors" : "")
    }
    //console.log(ne)
  }

  return (
    <Tooltip title={tooltip} arrow>
      <TextField
        label={(label ? label : "Year") + ": " + (year - birthYear)}
        name={name}
        type="number"
        disabled={disabled}
        slotProps={{
          htmlInput: {
            min: birthYear + minAge,
            max: birthYear + maxAge,
            step: 1,
          }
        }}
        error={!!errors[name]}
        helperText={errors[name]}
        onBlur={onBlur}
        required={required}
        onWheel={(e) => e.target instanceof HTMLElement && e.target.blur()}
        size="small"
        sx={{ width: width }}
        value={year}
        onChange={onChange}
        {...others}
      />
    </Tooltip>
  );
};
